@use '../../style/mixins';
@use '../../style/functions';
@import '../../../node_modules/tabulator-tables/src/scss/tabulator.scss';

/*
* @prop --table-max-column-width: defines a maximum width for columns using standard size units, to prevent the table from growing too wide. Set to `auto` if you do not need this limitation. Defaults to `40rem`.
*/

$width-of-sorter-arrow: 0.5rem;
$cell-padding: 0.5rem;
$table--has-interactive-rows--selectable-row--hover: 2;
$table--limel-table--row-selector: 1;
$height-of-aggregations-row: 1.5rem;

:host(limel-table) {
    isolation: isolate;
    display: block;
    --table-header-background-color: var(--contrast-500);
    --table-header-background-color--hover: var(--contrast-400);
    --table-header-background-color-when-being-dragged: var(--contrast-100);

    --table-row-background-color--odd: var(--contrast-200);
    --table-row-background-color--even: var(--contrast-100);
    --table-row-background-color--hover: var(
        --lime-elevated-surface-background-color
    );
    --table-row-background-color--active: var(--contrast-300);

    --table-arrow-color: var(--contrast-800);
    --table-arrow-color--active: var(
        --lime-primary-color,
        var(--limel-theme-primary-color)
    );

    --table-text-color: var(--limel-theme-text-primary-on-background-color);
    --limel-chip-size: 1.25rem;
}

@import './partial-styles/_table-main-layout';

#tabulator-container {
    position: relative;
}

#tabulator-container,
#tabulator-table {
    background-color: transparent;
    border: none;
}

.tabulator {
    .tabulator-header {
        color: var(--table-text-color);
    }
    .tabulator-tableHolder {
        .tabulator-table {
            color: var(--table-text-color);
            background-color: transparent;
        }
    }

    .tabulator-header {
        border-bottom: 0;
        background-color: rgb(var(--table-header-background-color));

        .tabulator-headers {
            width: fit-content;
        }

        .tabulator-col {
            transition: background-color 0.2s ease;
            background-color: rgb(var(--table-header-background-color));
            border-right-color: rgb(var(--contrast-200));

            &.tabulator-sortable {
                &:hover {
                    background-color: rgb(
                        var(--table-header-background-color--hover)
                    );
                }
            }

            .tabulator-col-content {
                padding-right: $width-of-sorter-arrow;
            }
        }

        .tabulator-col-title-holder {
            display: flex;
            gap: 0.25rem;
        }

        .tabulator-col-sorter {
            order: 1;
        }
        .tabulator-col-title {
            order: 2;
            font-weight: 500;
            padding-right: 0 !important;
            line-height: functions.pxToRem(20);
        }
    }
}

.tabulator-row {
    transition: background-color 0.2s ease;
    height: 2.25rem;

    &:hover {
        transition: background-color 0.1s ease;
    }

    &.tabulator-row-odd,
    &.tabulator-row-odd:hover {
        background-color: rgb(var(--table-row-background-color--odd));
    }

    &.tabulator-row-even,
    &.tabulator-row-even:hover {
        background-color: rgb(var(--table-row-background-color--even));
    }

    .tabulator-cell {
        border-right: transparent;
        padding: $cell-padding;
        padding-left: $cell-padding + $width-of-sorter-arrow;

        height: inherit;

        &[style*='text-align: right;'] {
            justify-content: flex-end;
        }
        &[style*='text-align: center;'] {
            justify-content: center;
        }
    }

    .tabulator-col-resize-handle {
        display: none;
    }
}

.tabulator-col,
.tabulator-cell {
    max-width: var(--table-max-column-width, 40rem);
}

#tabulator-loader,
#tabulator-empty-text {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

#tabulator-loader {
    background-color: rgba(var(--contrast-100), 0.6);
    cursor: wait;
}

#tabulator-empty-text {
    color: rgb(var(--contrast-800));
    font-weight: bold;
    font-size: functions.pxToRem(20);
    pointer-events: none;
}

limel-chip {
    transform: translateY(-0.15rem);
}

@import './partial-styles/tabulator-arrow';
@import './partial-styles/tabulator-paginator';
@import './partial-styles/tabulator-loader';
@import './partial-styles/tabulator-custom-styles';
@import './partial-styles/header-component';
@import './partial-styles/movable-columns';
@import './partial-styles/_tabulator-footer';
@import './partial-styles/_row-selection';
